import { WindowLocation } from '@gatsbyjs/reach-router';
import Flow, { FlowStep } from '../../flow/flow';
import FormComponent from '../forms.component';
import Review from '../review';

interface RouteParams {
	id: string;
};

export const routes = {
	form: ':id',
	review: 'review'
}

export class FormsFlow extends Flow {

	get steps(): FlowStep[] {
		return [
			{
				path: routes.form,
				component: FormComponent,
				flow: this
			},
			{
				path: routes.review,
				component: Review,
				flow: this
			}
		];
	}

	next(location: WindowLocation, params?: RouteParams) {
		const currentFormId = params?.id;
		if (location.pathname.includes(routes.review)) {
			this.onEnd(location);
		} else if (currentFormId) {
			const forms = this.ctxt.json.getFilteredForms(
				this.enrollmentCtxt.input.performer,
				this.enrollmentCtxt.input.discardedServices,
				this.enrollmentCtxt.input.questions,
				this.enrollmentCtxt.input.consents
			);
			if (+currentFormId < forms.length) {
				const formNumber = currentFormId + 1;
				this.navigate(formNumber);
			} else {
				this.navigate(routes.review);
			}
		} else {
			this.navigate('1', { replace: true });
		}
	}

}

export default FormsFlow;
